(function () {
  function initSection(section) {
    const viewport = section.querySelector('.vnk-carousel');
    const track    = section.querySelector('.vnk-carousel__track');
    if (!viewport || !track) return;

    let slides = Array.from(track.querySelectorAll('.vnk-slide'));
    const total = slides.length;
    if (total <= 1) return; // nothing to swipe

    // Infinite loop: clone edges
    const firstClone = slides[0].cloneNode(true);
    const lastClone  = slides[slides.length - 1].cloneNode(true);
    track.appendChild(firstClone);
    track.insertBefore(lastClone, track.firstChild);
    slides = Array.from(track.querySelectorAll('.vnk-slide'));

    // State
    let index = 1; // start on first REAL slide
    let startX = 0, dx = 0, dragging = false, moved = false;

    // Measurements
    let width = 0;       // viewport clientWidth (includes padding)
    let padL = 0, padR = 0;
    let inner = 0;       // inner width = width - paddings
    let gap = 0;         // track's gap between slides
    let step = 0;        // how far to move per slide = inner + gap

    function measure() {
      const vcs = getComputedStyle(viewport);
      padL = parseFloat(vcs.paddingLeft)  || 0;
      padR = parseFloat(vcs.paddingRight) || 0;

      width = viewport.clientWidth;
      inner = width - padL - padR;

      const tcs = getComputedStyle(track);
      gap = parseFloat(tcs.columnGap || tcs.gap) || 0;

      step = inner + gap;
    }
    function setTransform(x, withTransition = true) {
      track.style.transition = withTransition ? 'transform .4s ease' : 'none';
      track.style.transform  = `translateX(${-index * step + x}px)`;
    }
    function snap() {
      const threshold = inner * 0.15;
      if (Math.abs(dx) > threshold) index += (dx < 0 ? 1 : -1);
      dx = 0;
      setTransform(0, true);
    }

    function onStart(x) {
      dragging = true; moved = false; startX = x; dx = 0;
      measure();
      setTransform(0, false);
    }
    function onMove(x, evt) {
      if (!dragging) return;
      dx = x - startX;
      if (Math.abs(dx) > 5) moved = true;
      setTransform(dx, false);
      if (evt) evt.preventDefault(); // keep gesture horizontal
    }
    function onEnd() {
      if (!dragging) return;
      dragging = false; snap();
    }

    // Wrap from clones to real slides
    track.addEventListener('transitionend', () => {
      if (index === 0) {            // landed on leading clone
        index = total;              // last REAL
        setTransform(0, false);
      } else if (index === total + 1) { // landed on trailing clone
        index = 1;                  // first REAL
        setTransform(0, false);
      }
    });

    // Touch + mouse
    track.addEventListener('touchstart', e => onStart(e.touches[0].clientX), { passive: true });
    track.addEventListener('touchmove',  e => onMove(e.touches[0].clientX, e), { passive: false });
    track.addEventListener('touchend',   onEnd);
    track.addEventListener('mousedown',  e => { e.preventDefault(); onStart(e.clientX); });
    window.addEventListener('mousemove', e => dragging && onMove(e.clientX));
    window.addEventListener('mouseup',   onEnd);

    // Block click-through when swiping
    track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

    // First layout + resize
    measure();
    setTransform(0, false);
    const ro = 'ResizeObserver' in window ? new ResizeObserver(() => { measure(); setTransform(0, false); }) : null;
    if (ro) ro.observe(viewport); else window.addEventListener('resize', () => { measure(); setTransform(0, false); });
  }

  // Init all sections of this type
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('section[data-section-type="product-grid"]').forEach(initSection);
  });
  // Theme editor hot-reloads
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('section[data-section-type="product-grid"]');
    if (section) initSection(section);
  });
})();
